import { createInstance } from '@datapunt/matomo-tracker-react'
import { MATOMO_SITE_ID, STATS_CONTROL_D_DOMAIN } from 'gatsby-env-variables'

const instance = createInstance({
  urlBase: STATS_CONTROL_D_DOMAIN,
  siteId: MATOMO_SITE_ID,
  linkTracking: false,
})

export default instance
